var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SubPage", {
    attrs: { pageMode: _vm.pageMode, onSwitchMode: _vm.onSwitchMode },
    scopedSlots: _vm._u([
      {
        key: "main_page",
        fn: function () {
          return [
            _c(
              "div",
              {
                key: _vm.reRender,
                staticClass:
                  "d-flex question-screen justify-content-center flex-wrap",
              },
              [
                _vm.exam
                  ? _c("v-flex", { attrs: { xs12: "" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "mt-3 center-layout",
                          attrs: { column: "" },
                        },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("img", {
                                staticClass: "flex xs8 sm8 lg3",
                                staticStyle: { width: "20%" },
                                attrs: { src: _vm.exam.image.url },
                              }),
                              _vm._v(" "),
                              _c("h1", { staticClass: "mt-2" }, [
                                _vm._v(_vm._s(_vm.exam.name)),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.exam.description) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.exam.isDone(_vm.userExam) &&
                              _vm.userExam.isWaitingScoreCheck
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            rounded: "",
                                            color: "warning",
                                            dark: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "exam_result.check_score"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm.exam.isDone(_vm.userExam)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "cursor-pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.gotoResult(
                                            _vm.exam,
                                            _vm.userExam
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("ExamComponent", {
                                        attrs: {
                                          exam: _vm.exam,
                                          isMine: true,
                                          list: _vm.allExams,
                                          onlyAction: true,
                                          userExam: _vm.userExam,
                                          schoolSetting: _vm.schoolSetting,
                                          onShowHistories: _vm.onShowHistories,
                                        },
                                        on: { fetchList: _vm.fetchExams },
                                      }),
                                    ],
                                    1
                                  )
                                : !_vm.exam.isStarted(_vm.userExam)
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        rounded: "",
                                        color: "primary",
                                        dark: "",
                                        cytag: "start-test",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.startExam(
                                            _vm.exam,
                                            _vm.userExam
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("exam_show.start")) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm.exam.isTestTimeOver(_vm.userExam)
                                ? [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          rounded: "",
                                          color: "red",
                                          dark: "",
                                          cytag: "over-test",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.resultExam(
                                              _vm.exam,
                                              _vm.userExam
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("exam_show.time_over")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mt-2 red--text" },
                                      [
                                        _vm._v(
                                          "このテストは時間を超過しています。"
                                        ),
                                      ]
                                    ),
                                  ]
                                : _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        rounded: "",
                                        color: "primary",
                                        dark: "",
                                        cytag: "continue-test",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.continueExam(
                                            _vm.exam,
                                            _vm.userExam
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("exam_show.continue")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("portal", { attrs: { to: "header-left" } }, [
                  _vm.exam
                    ? _c(
                        "div",
                        { staticClass: "d-flex align-center minus-left" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mk-0",
                              attrs: { icon: "" },
                              on: { click: _vm.toExamList },
                            },
                            [_c("v-icon", [_vm._v("keyboard_arrow_left")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-toolbar-title",
                            {
                              class: { "ps-0": _vm.mobile },
                              style: { color: _vm.headerNavTextColor },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.exam.name) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "sub_page",
        fn: function () {
          return [
            _vm.subPageExam
              ? _c("ExamComponent", {
                  attrs: {
                    exam: _vm.subPageExam,
                    isMine: true,
                    list: _vm.allExams,
                    schoolSetting: _vm.schoolSetting,
                  },
                  on: { fetchList: _vm.fetchExams },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }